import { Grid, Paper } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useMemo, useState } from 'react';
import { ListTopBar } from '../ListTopBar/ListTopBar';
import { TextMessage } from '../TextMessage/TextMessage';
import { GRID_DEFAULT_LOCALE_TEXT } from './SahinDataTable.model';
import { useStyles } from './SahinDataTable.styles';
import {
  SahinDataTableProps,
  defaultRowParams,
  generalColumns,
} from './SahinDataTable.types';

export const SahinDataTable = ({
  data,
  columns,
  showProperty,
  onEdit,
  onAdd,
  onDelete,
  customActionComponent,
  customActionComponentTitle,
  actionButtonColumnWidth,
  customEmptyMessage,
  toolbox,
  rightToolbox,
  currentPage,
  totalPages,
  totalData,
  onPageChange,
  pageSize = 15,
  onPageSizeChange,
  ...rest
}: SahinDataTableProps) => {
  const classes = useStyles();
  const [selected, setSelected] = useState<any[]>([]);
  const selectedItem = data?.find((item: any) => item.id === selected?.[0]);
  const currentColumns = useMemo<GridColDef[]>(
    () => [
      {
        ...defaultRowParams,
        field: 'rowNumber',
        headerAlign: 'center',
        align: 'center',
        headerName: '✦',
        width: 100,
        renderCell: (params) => {
          const currentPageIndex = currentPage ? currentPage - 1 : 0;
          return (
            currentPageIndex * pageSize +
            params.api.getRowIndex(params.row.id) +
            1
          );
        },
      },
      ...columns.map((item: any) => ({ ...defaultRowParams, ...item })),
      ...generalColumns({
        onEdit,
        onDelete,
        customActionComponent,
        showProperty,
        customActionComponentTitle,
        actionButtonColumnWidth,
      }),
    ],
    [
      columns,
      onEdit,
      onDelete,
      customActionComponent,
      showProperty,
      customActionComponentTitle,
      actionButtonColumnWidth,
      currentPage,
      pageSize,
    ],
  );

  const onSelect = (selected: any) => {
    setSelected(selected);
  };

  return (
    <Grid
      className={classes.root}
      component={Paper}
      flexDirection="column"
      container
    >
      <ListTopBar
        onAdd={onAdd}
        onEdit={onEdit}
        selected={selected.length === 1 && selectedItem}
        toolbox={toolbox}
        rightToolbox={rightToolbox}
      />
      {(data?.length > 0 || (!data?.length && currentPage !== 1)) && (
        <DataGrid
          key={`${pageSize}-${currentPage}`} // Force re-render when pageSize or currentPage changes
          rows={data || []}
          pageSize={pageSize}
          page={currentPage ? currentPage - 1 : 0}
          rowCount={totalData || data?.length || 0}
          columns={currentColumns}
          className={classes.dataTable}
          onSelectionModelChange={(value) => onSelect(value)}
          onPageChange={(newPage) => onPageChange?.(newPage + 1)}
          onPageSizeChange={(newPageSize) => onPageSizeChange?.(newPageSize)}
          rowsPerPageOptions={[15, 25, 50, 100]}
          pagination
          paginationMode="server"
          localeText={GRID_DEFAULT_LOCALE_TEXT}
          componentsProps={{
            pagination: {
              labelRowsPerPage: 'Sayfa başına:',
              labelDisplayedRows: ({
                from,
                to,
                count,
              }: {
                from: number;
                to: number;
                count: number;
              }) =>
                `${from}-${to} / ${count !== -1 ? count : `${to}den fazla`}`,
            },
          }}
          {...rest}
        />
      )}
      {!data?.length &&
        currentPage === 1 &&
        (customEmptyMessage ?? <TextMessage text="VERİ YOK" />)}
    </Grid>
  );
};
